import React, { FC, useMemo } from 'react';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Tag } from 'antd';
import HyperLink, { ENTITY_TYPE } from '../common/HyperLink';
import ViaStockLocationDisplay, { getSLHyperLink, SL_TAG } from './ViaStockLocationDisplay';

const LocationStockLocationNameWithType: FC<any> = ({
	record,
	backLinkText,
	viaStockLocation,
}): React.ReactElement => {
	const tag = useMemo(
		() =>
			nullSafeGet('location', record) ? (
				<Tag color="#e8def8" style={{ color: '#4a1e87' }}>
					L
				</Tag>
			) : (
				SL_TAG
			),
		[record]
	);

	const name = useMemo(
		() =>
			nullSafeGet('location', record) ? (
				<HyperLink
					text={nullSafeGetOrElse('location.name', record, '--')}
					entityType={ENTITY_TYPE.LOCATION}
					entityId={nullSafeGetOrElse('location.id', record, '--')}
					backLinkText={backLinkText}
				/>
			) : (
				getSLHyperLink(nullSafeGet('stockLocation', record), backLinkText)
			),
		[backLinkText, record]
	);

	return (
		<div className="flex flex-col gap-2">
			<div className="flex flex-row items-center">
				{tag}
				{name}
			</div>
			<ViaStockLocationDisplay viaStockLocation={viaStockLocation} backLinkText={backLinkText} />
		</div>
	);
};

export default LocationStockLocationNameWithType;
